import { render, staticRenderFns } from "./ItemBrandsList.vue?vue&type=template&id=2632a023&scoped=true"
import script from "./ItemBrandsList.vue?vue&type=script&lang=js"
export * from "./ItemBrandsList.vue?vue&type=script&lang=js"
import style0 from "./ItemBrandsList.vue?vue&type=style&index=0&id=2632a023&prod&lang=scss&scoped=true"
import style1 from "./ItemBrandsList.vue?vue&type=style&index=1&id=2632a023&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2632a023",
  null
  
)

export default component.exports